module.exports = __webpack_public_path__ + "img/intro_s2_3.c8ebfb2d.png";